import React from "react";
import styles from "./skeleton.css";

const Skeleton = () => {
    return (
        <React.Fragment>
            <div className="container">
                <div className="shimmer" styleName={"styles.breadcrumpShimmer"} />
            </div>
            <div className="container">
                <div className={"row"}>
                    <div className={"col-md-10"} styleName={"styles.shimmerHorzontalslide"}>
                        <div className="shimmer" styleName={"styles.shimmerLeftImage"} />
                    </div>
                </div>
            </div>
            <div className="container" styleName={"styles.carouselImages"}>
                <div className="shimmer" styleName={"styles.shimmerBottomTab"} />
                <div className="shimmer" styleName={"styles.shimmerBottomTab"} />
                <div className="shimmer" styleName={"styles.shimmerBottomTab"} />
                <div className="shimmer" styleName={"styles.shimmerBottomTab"} />
                <div className="shimmer" styleName={"styles.shimmerBottomTab"} />
                <div className="shimmer" styleName={"styles.shimmerBottomTab"} />
            </div>
        </React.Fragment>
    );
};

export default Skeleton;
